import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _regeneratorRuntime from "@babel/runtime/regenerator";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import React from 'react';
import { withAnalyticsEvents } from '@atlaskit/analytics-next';
import { ANALYTICS_MEDIA_CHANNEL, getMediaFeatureFlag, withMediaAnalyticsContext } from '@atlaskit/media-common';
import { isWebkitSupported } from '@atlaskit/media-ui/browser';
import { getFilesFromItems, getFilesFromFileSystemEntries } from 'flat-files';
import { LocalUploadComponentReact } from '../localUploadReact';
import { getPackageAttributes } from '../../util/analytics';
import UploadRejectionFlagGroup from '../uploadRejectionFlagGroup/UploadRejectionFlagGroup';
function dragContainsFiles(event) {
  if (!event.dataTransfer) {
    return false;
  }
  var types = event.dataTransfer.types;
  return Array.from(types).indexOf('Files') > -1;
}
var COMPONENT_NAME = 'dropzone';
export var DropzoneBase = /*#__PURE__*/function (_LocalUploadComponent) {
  _inherits(DropzoneBase, _LocalUploadComponent);
  var _super = _createSuper(DropzoneBase);
  function DropzoneBase(props) {
    var _this;
    _classCallCheck(this, DropzoneBase);
    _this = _super.call(this, props, COMPONENT_NAME);
    _defineProperty(_assertThisInitialized(_this), "uiActive", false);
    _defineProperty(_assertThisInitialized(_this), "addContainerListeners", function () {
      var container = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _this.getContainer();
      container.addEventListener('dragover', _this.onDragOver, false);
      container.addEventListener('dragleave', _this.onDragLeave, false);
      container.addEventListener('drop', _this.onFileDropped);
    });
    _defineProperty(_assertThisInitialized(_this), "removeContainerListeners", function () {
      var container = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _this.getContainer();
      container.removeEventListener('dragover', _this.onDragOver, false);
      container.removeEventListener('dragleave', _this.onDragLeave, false);
      container.removeEventListener('drop', _this.onFileDropped);
    });
    _defineProperty(_assertThisInitialized(_this), "onDragOver", function (event) {
      event.preventDefault();
      if (event.dataTransfer && dragContainsFiles(event)) {
        var dataTransfer = event.dataTransfer;
        var allowed;
        try {
          allowed = dataTransfer.effectAllowed;
        } catch (e) {} // the error is expected in IE11

        dataTransfer.dropEffect = 'move' === allowed || 'linkMove' === allowed ? 'move' : 'copy';
        var length = _this.getDraggedItemsLength(dataTransfer);
        // [EDM-1636]: needed in order to make multiple dropzones in the page to work
        event.stopPropagation();
        _this.emitDragOver({
          length: length
        });
      }
    });
    _defineProperty(_assertThisInitialized(_this), "onDragLeave", function (e) {
      if (e.dataTransfer) {
        e.preventDefault();
        var length = 0;
        if (dragContainsFiles(e)) {
          var dataTransfer = e.dataTransfer;
          length = _this.getDraggedItemsLength(dataTransfer);
        }
        _this.emitDragLeave({
          length: length
        });
      }
    });
    _defineProperty(_assertThisInitialized(_this), "onFileDropped", /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(dragEvent) {
        var featureFlags, flattenedDirectoryFiles, files;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (dragEvent.dataTransfer) {
                _context.next = 2;
                break;
              }
              return _context.abrupt("return");
            case 2:
              dragEvent.preventDefault();
              dragEvent.stopPropagation();
              featureFlags = _this.props.featureFlags; // refreshes uploadParams as only set once in parent constructor
              _this.setUploadParams(_this.props.config.uploadParams);
              /*
               * Only enable support for folders if (1) the browser is supported (2) feature flag is enabled
               * The file flattening library used to add support for Folders uses a function called webkitEntry.
               * Some browser types are not supported https://developer.mozilla.org/en-US/docs/Web/API/HTMLInputElement/webkitEntries
               */
              if (!(isWebkitSupported() && getMediaFeatureFlag('folderUploads', featureFlags))) {
                _context.next = 15;
                break;
              }
              _this.fireAnalyticsForFolders(dragEvent.dataTransfer.items);
              _context.next = 10;
              return _this.getFilesFromDragEvent(dragEvent.dataTransfer.items);
            case 10:
              flattenedDirectoryFiles = _context.sent;
              _this.onDropFolders(flattenedDirectoryFiles.length);
              _this.uploadService.addFiles(flattenedDirectoryFiles);
              _context.next = 18;
              break;
            case 15:
              _this.onDrop(dragEvent);
              files = Array.from(dragEvent.dataTransfer.files);
              _this.uploadService.addFiles(files);
            case 18:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }());
    /*
     * Checks how many folders are uploaded in a single drag and drop. Then, fires an analytic event in accordance to this.
     */
    _defineProperty(_assertThisInitialized(_this), "fireAnalyticsForFolders", function (items) {
      //convert DataTransferItemList into an array of DataTransferItem(s)
      var toArray = Array.from(items);

      //function to check if a file entry is a folder
      var hasFolder = function hasFolder(item) {
        var _item$webkitGetAsEntr;
        return (_item$webkitGetAsEntr = item.webkitGetAsEntry()) === null || _item$webkitGetAsEntr === void 0 ? void 0 : _item$webkitGetAsEntr.isDirectory;
      };

      //how many folders are in a single drag and drop event
      var folderCount = toArray.filter(function (item) {
        return hasFolder(item);
      }).length;

      // fires analytic events if number of folders is more than 0
      if (folderCount > 0) {
        _this.fireAnalyticsEvent('folderDroppedInto', folderCount);
      }
    });
    /*
     * Files dropped contains a directory. Thus, flatten the directory to return an array of Files.
     */
    _defineProperty(_assertThisInitialized(_this), "getFilesFromDragEvent", /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(dragEventItemList) {
        var items, fileSystemEntries, files;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              items = dragEventItemList; //If items consist of directory or directories, flatten it to grab the files only. Else, just get the files
              _context2.next = 3;
              return getFilesFromItems(items);
            case 3:
              fileSystemEntries = _context2.sent;
              _context2.next = 6;
              return getFilesFromFileSystemEntries(fileSystemEntries);
            case 6:
              files = _context2.sent;
              return _context2.abrupt("return", _this.filterFilesAgainstBlacklist(files));
            case 8:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }));
      return function (_x2) {
        return _ref2.apply(this, arguments);
      };
    }());
    _defineProperty(_assertThisInitialized(_this), "filterFilesAgainstBlacklist", function (files) {
      // We don't want these files in our final File list
      var blacklist = ['.DS_Store', 'thumbs.db', 'desktop.ini'];

      // Filter Files using our defined blacklist
      return files.filter(function (file) {
        return !blacklist.includes(file.name);
      });
    });
    // Similar to the onDrop event, but for folders.
    _defineProperty(_assertThisInitialized(_this), "onDropFolders", function (fileCount) {
      if (fileCount > 0) {
        _this.sendAnalyticsAndEmitDragLeave(fileCount);
      }
    });
    _defineProperty(_assertThisInitialized(_this), "onDrop", function (e) {
      if (e.dataTransfer && dragContainsFiles(e)) {
        var dataTransfer = e.dataTransfer;
        var fileCount = _this.getDraggedItemsLength(dataTransfer);
        _this.sendAnalyticsAndEmitDragLeave(fileCount);
      }
    });
    _defineProperty(_assertThisInitialized(_this), "sendAnalyticsAndEmitDragLeave", function (fileCount) {
      _this.fireAnalyticsEvent('droppedInto', fileCount);
      if (_this.props.onDrop) {
        _this.props.onDrop();
      }
      _this.emitDragLeave({
        length: fileCount
      });
    });
    return _this;
  }
  _createClass(DropzoneBase, [{
    key: "getContainer",
    value: function getContainer() {
      var container = this.props.config.container;
      return container || document.body;
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var onCancelFn = this.props.onCancelFn;
      this.addContainerListeners(this.getContainer());
      if (onCancelFn) {
        onCancelFn(this.cancel);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.removeContainerListeners(this.getContainer());
    }
  }, {
    key: "UNSAFE_componentWillReceiveProps",
    value: function UNSAFE_componentWillReceiveProps(nextProps) {
      var newContainer = nextProps.config.container;
      var oldContainer = this.props.config.container;
      if (newContainer !== oldContainer) {
        this.removeContainerListeners(oldContainer);
        this.addContainerListeners(newContainer);
      }
    }
  }, {
    key: "getDraggedItemsLength",
    value:
    // Cross-browser way of getting dragged items length, we prioritize "items" if present
    // https://www.w3.org/TR/html51/editing.html#the-datatransfer-interface
    // This method is used on 'dragover' and we have no way to retrieve FileSystemFileEntry,
    // which contains info about if the dropped item is a file or directory. That info is only
    // available on 'drop'
    function getDraggedItemsLength(dataTransfer) {
      if (dataTransfer.items) {
        var items = Array.from(dataTransfer.items);
        return items.filter(function (i) {
          return i.kind === 'file';
        }).length;
      }
      // This is required for IE11
      return dataTransfer.files.length;
    }
  }, {
    key: "emitDragOver",
    value: function emitDragOver(payload) {
      if (!this.uiActive) {
        var onDragEnter = this.props.onDragEnter;
        this.uiActive = true;
        this.fireAnalyticsEvent('draggedInto', payload.length);
        if (onDragEnter) {
          onDragEnter(payload);
        }
      }
    }
  }, {
    key: "emitDragLeave",
    value: function emitDragLeave(payload) {
      var _this2 = this;
      if (this.uiActive) {
        this.uiActive = false;
        /*
         when drag over child elements, container will issue dragleave and then dragover immediately.
         The 50ms timeout will prevent from issuing that "false" dragleave event
         */
        window.setTimeout(function () {
          if (!_this2.uiActive) {
            var onDragLeave = _this2.props.onDragLeave;
            _this2.fireAnalyticsEvent('draggedOut', payload.length);
            if (onDragLeave) {
              onDragLeave(payload);
            }
          }
        }, 50);
      }
    }
  }, {
    key: "fireAnalyticsEvent",
    value: function fireAnalyticsEvent(action, fileCount) {
      var createAnalyticsEvent = this.props.createAnalyticsEvent;
      if (createAnalyticsEvent) {
        var _payload = {
          eventType: 'ui',
          actionSubject: 'dropzone',
          action: action,
          attributes: {
            fileCount: fileCount
          }
        };
        var analyticsEvent = createAnalyticsEvent(_payload);
        analyticsEvent.fire(ANALYTICS_MEDIA_CHANNEL);
      }
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(UploadRejectionFlagGroup, {
        flagData: this.state.uploadRejectionFlags,
        onFlagDismissed: this.dismissUploadRejectionFlag
      });
    }
  }]);
  return DropzoneBase;
}(LocalUploadComponentReact);
export default DropzoneBase;
export var Dropzone = withMediaAnalyticsContext(getPackageAttributes(COMPONENT_NAME))(withAnalyticsEvents()(DropzoneBase));